import { RankingItem } from '../utils/RankingItem';

export class AbstractImageService{
    
  
  public getProgressBarBg():string{
    return "/assets/images/gameboard/dynamicpanel/progressbarbg.png";
  }

  public getProgressBarBg2():string{
    return "/assets/images/gameboard/dynamicpanel/progressbarbg2.png";
  }
  public getProgressBarIndicator():string{
    return "/assets/images/gameboard/dynamicpanel/progressbarindicator.png";
  }
  
    public getPlayerSlot(me:boolean):string
    {
      if (me)
      {
        return "/assets/images/rankings/slot_player.png";
      }
      else
      {
        return "/assets/images/rankings/tournament_slot1_out.png";
      }
    }

  public generateEmptySlot():RankingItem
  {			
    var emptyItem:RankingItem = new RankingItem("deleted", "deleted", "deleted", 0, false, false, 0, 0);
    emptyItem.setBackgroundImg(this.getEmptyRankingSlot());
    emptyItem.setEmpty(true);
    return emptyItem;
  }

  public getEmptyRankingSlot():string
  {
    return "/assets/images/rankings/tournament_slot_nofriends.png";
  }
}